import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TaskDossier\DeleteTaskDossierController::deleteMethod
* @see app/Http/Controllers/TaskDossier/DeleteTaskDossierController.php
* @route '/api/task-dossier/{task_dossier}'
*/
export const deleteMethod = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/task-dossier/{task_dossier}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\TaskDossier\DeleteTaskDossierController::deleteMethod
* @see app/Http/Controllers/TaskDossier/DeleteTaskDossierController.php
* @route '/api/task-dossier/{task_dossier}'
*/
deleteMethod.url = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { task_dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { task_dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            task_dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        task_dossier: typeof args.task_dossier === 'object'
        ? args.task_dossier.id
        : args.task_dossier,
    }

    return deleteMethod.definition.url
            .replace('{task_dossier}', parsedArgs.task_dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\DeleteTaskDossierController::deleteMethod
* @see app/Http/Controllers/TaskDossier/DeleteTaskDossierController.php
* @route '/api/task-dossier/{task_dossier}'
*/
deleteMethod.delete = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\TaskDossier\DeleteTaskDossierController::undo
* @see app/Http/Controllers/TaskDossier/DeleteTaskDossierController.php
* @route '/api/task-dossier/{id}/undo-delete'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/task-dossier/{id}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TaskDossier\DeleteTaskDossierController::undo
* @see app/Http/Controllers/TaskDossier/DeleteTaskDossierController.php
* @route '/api/task-dossier/{id}/undo-delete'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\DeleteTaskDossierController::undo
* @see app/Http/Controllers/TaskDossier/DeleteTaskDossierController.php
* @route '/api/task-dossier/{id}/undo-delete'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TaskDossier\DeleteTaskDossierController::undo
* @see app/Http/Controllers/TaskDossier/DeleteTaskDossierController.php
* @route '/api/task-dossier/{id}/undo-delete'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteTaskDossierController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteTaskDossierController